import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AccountV2Service } from 'src/app/services/account-v2.service';


export type AccountAsyncMessageKeys = 'accountalreadyexists' | 'asyncvalidationerror';


@Injectable({ providedIn: 'root' })
export class AccountAsyncValidationService {
  constructor(private readonly accountService: AccountV2Service) {}

  accountCnpjAlredyExists(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) {
        return of(null);
      }

      return timer(500).pipe(
        switchMap(() => this.accountService.cnpjAlredyExists(control.value)),
        map((exists) => (exists ? { accountalreadyexists: true } : null)),
        catchError(() => of({ asyncvalidationerror: true }))
      );
    };
  }

  accountCpfAlredyExists(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) {
        return of(null);
      }
      
      return timer(500).pipe(
        switchMap(() => this.accountService.cpfAlredyExists(control.value)),
        map((exists) => (exists ? { accountalreadyexists: true } : null)),
        catchError(() => of({ asyncvalidationerror: true }))
      );
    };
  }

  accountEmailAlredyExists(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) {
        return of(null);
      }
      
      return timer(500).pipe(
        switchMap(() => this.accountService.emailAlredyExists(control.value)),
        map((exists) => (exists ? { accountalreadyexists: true } : null)),
        catchError(() => of({ asyncvalidationerror: true }))
      );
    };
  }
}